import type { ReserveInputContext } from '~/navigation'
import { useInitAtom } from '../store/init'

type Props = {
  context: ReserveInputContext
}

export function InitAtom({ context }: Props) {
  useInitAtom(context)
  return null
}
